import { DEFAULT_ENV } from "./environment.default";

export const environment = {
  ...DEFAULT_ENV,
  production: true,
  apiBase: "https://testnet-api.pqabelian.io/v2",
};
